import { render, staticRenderFns } from "./CardArea.vue?vue&type=template&id=7670dc32&"
import script from "./CardArea.vue?vue&type=script&lang=js&"
export * from "./CardArea.vue?vue&type=script&lang=js&"
import style0 from "./CardArea.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports